export default __webpack_public_path__ + "static/media/apple-pay.43582aa5.svg";